import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'
const routes = [
  {
    path: '/material',
    name: 'material',
    meta: { title: '物料' },
    redirect: '/material/inventory',
    component: Main,
    children: [
      // 库存管理
      {
        path: '/material/inventory',
        name: 'material_inventory',
        meta: {
          title: '库存管理',
          parentPath: '/material',
          icon: 'icon_fenxiao_goods',
          permission: ['view'],
          keepAlive: true
        },
        redirect: '/material/inventory/lists',
        component: Blank,
        children: [
          {
            path: '/material/inventory/lists',
            name: 'material_inventory_lists',
            meta: {
              title: '库存列表',
              parentPath: '/material',
              permission: ['view'],
              keepAlive: true
            },
            component: () => import('@/views/material/inventory/lists.vue')
          }
          // {
          //     path: '/material/inventory/warning',
          //     name: 'material_inventory_warning',
          //     meta: {
          //         title: '库存预警',
          //         parentPath: '/material',
          //         permission: ['view'],
          //         keepAlive: true
          //     },
          //     component: () => import('@/views/material/inventory/warning.vue')
          // },
          // {
          //     path: '/material/inventory/expiry',
          //     name: 'material_inventory_expiry',
          //     meta: {
          //         title: '临期预警',
          //         parentPath: '/material',
          //         permission: ['view'],
          //         keepAlive: true
          //     },
          //     component: () => import('@/views/material/inventory/expiry.vue')
          // },
          // {
          //     path: '/material/inventory/transfer',
          //     name: 'material_inventory_transfer',
          //     meta: {
          //         title: '库存调拨',
          //         parentPath: '/material',
          //         permission: ['view']
          //     },
          //     component: () => import('@/views/material/inventory/transfer.vue')
          // }
        ]
      },
      // 物料分类管理
      {
        path: '/material/category',
        name: 'material_category',
        meta: {
          title: '费用分类',
          parentPath: '/material',
          icon: 'icon_sort',
          permission: ['view'],
          keepAlive: true
        },
        component: () => import('@/views/material/category.vue')
      },
      // // 供应商管理
      {
        path: '/material/supplier',
        name: 'material_supplier',
        meta: {
          title: '供应商管理',
          parentPath: '/material',
          icon: 'icon_gongyingshang',
          permission: ['view'],
          keepAlive: true
        },
        redirect: '/material/supplier/lists',
        component: Blank,
        children: [
          {
            path: '/material/supplier/lists',
            name: 'material_supplier_lists',
            meta: {
              title: '供应商列表',
              parentPath: '/material',
              permission: ['view'],
              keepAlive: true
            },
            component: () => import('@/views/material/supplier/lists.vue')
          }
          // {
          //     path: '/material/supplier/blacklist',
          //     name: 'material_supplier_blacklist',
          //     meta: {
          //         title: '供应商黑名单',
          //         parentPath: '/material',
          //         permission: ['view']
          //     },
          //     component: () => import('@/views/material/supplier/blacklist.vue')
          // },
          // {
          //     path: '/material/supplier/rating',
          //     name: 'material_supplier_rating',
          //     meta: {
          //         title: '供应商评级',
          //         parentPath: '/material',
          //         permission: ['view']
          //     },
          //     component: () => import('@/views/material/supplier/rating.vue')
          // }
        ]
      },
      // // 采购管理
      // {
      //     path: '/material/purchase',
      //     name: 'material_purchase',
      //     meta: {
      //         title: '采购管理',
      //         parentPath: '/material',
      //         icon: 'icon_cai_gou',
      //         permission: ['view'],
      //         keepAlive: true
      //     },
      //     redirect: '/material/purchase/order',
      //     component: Blank,
      //     children: [
      //         {
      //             path: '/material/purchase/order',
      //             name: 'material_purchase_order',
      //             meta: {
      //                 title: '采购订单',
      //                 parentPath: '/material',
      //                 permission: ['view'],
      //                 keepAlive: true
      //             },
      //             component: () => import('@/views/material/purchase/order.vue')
      //         },
      //         {
      //             path: '/material/purchase/plan',
      //             name: 'material_purchase_plan',
      //             meta: {
      //                 title: '采购计划',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/purchase/plan.vue')
      //         },
      //         {
      //             path: '/material/purchase/audit',
      //             name: 'material_purchase_audit',
      //             meta: {
      //                 title: '采购审批',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/purchase/audit.vue')
      //         },
      //         {
      //             path: '/material/purchase/return',
      //             name: 'material_purchase_return',
      //             meta: {
      //                 title: '采购退货',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/purchase/return.vue')
      //         }
      //     ]
      // },
      // // 入库管理
      // {
      //     path: '/material/inbound',
      //     name: 'material_inbound',
      //     meta: {
      //         title: '入库管理',
      //         parentPath: '/material',
      //         icon: 'icon_ru_ku',
      //         permission: ['view'],
      //         keepAlive: true
      //     },
      //     redirect: '/material/inbound/lists',
      //     component: Blank,
      //     children: [
      //         {
      //             path: '/material/inbound/lists',
      //             name: 'material_inbound_lists',
      //             meta: {
      //                 title: '入库记录',
      //                 parentPath: '/material',
      //                 permission: ['view'],
      //                 keepAlive: true
      //             },
      //             component: () => import('@/views/material/inbound/lists.vue')
      //         },
      //         {
      //             path: '/material/inbound/inspection',
      //             name: 'material_inbound_inspection',
      //             meta: {
      //                 title: '入库质检',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/inbound/inspection.vue')
      //         },
      //         {
      //             path: '/material/inbound/return',
      //             name: 'material_inbound_return',
      //             meta: {
      //                 title: '退货入库',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/inbound/return.vue')
      //         }
      //     ]
      // },
      // // 出库管理
      // {
      //     path: '/material/outbound',
      //     name: 'material_outbound',
      //     meta: {
      //         title: '出库管理',
      //         parentPath: '/material',
      //         icon: 'icon_chu_ku',
      //         permission: ['view'],
      //         keepAlive: true
      //     },
      //     redirect: '/material/outbound/lists',
      //     component: Blank,
      //     children: [
      //         {
      //             path: '/material/outbound/lists',
      //             name: 'material_outbound_lists',
      //             meta: {
      //                 title: '出库记录',
      //                 parentPath: '/material',
      //                 permission: ['view'],
      //                 keepAlive: true
      //             },
      //             component: () => import('@/views/material/outbound/lists.vue')
      //         },
      //         {
      //             path: '/material/outbound/apply',
      //             name: 'material_outbound_apply',
      //             meta: {
      //                 title: '领用申请',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/outbound/apply.vue')
      //         },
      //         {
      //             path: '/material/outbound/scrap',
      //             name: 'material_outbound_scrap',
      //             meta: {
      //                 title: '报废出库',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/outbound/scrap.vue')
      //         },
      //         {
      //             path: '/material/outbound/transfer',
      //             name: 'material_outbound_transfer',
      //             meta: {
      //                 title: '调拨出库',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/outbound/transfer.vue')
      //         }
      //     ]
      // },
      // // 库存盘点
      // {
      //     path: '/material/check',
      //     name: 'material_check',
      //     meta: {
      //         title: '库存盘点',
      //         parentPath: '/material',
      //         icon: 'icon_pan_dian',
      //         permission: ['view'],
      //         keepAlive: true
      //     },
      //     redirect: '/material/check/lists',
      //     component: Blank,
      //     children: [
      //         {
      //             path: '/material/check/lists',
      //             name: 'material_check_lists',
      //             meta: {
      //                 title: '盘点记录',
      //                 parentPath: '/material',
      //                 permission: ['view'],
      //                 keepAlive: true
      //             },
      //             component: () => import('@/views/material/check/lists.vue')
      //         },
      //         {
      //             path: '/material/check/plan',
      //             name: 'material_check_plan',
      //             meta: {
      //                 title: '盘点计划',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/check/plan.vue')
      //         },
      //         {
      //             path: '/material/check/adjust',
      //             name: 'material_check_adjust',
      //             meta: {
      //                 title: '盘点调整',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/check/adjust.vue')
      //         }
      //     ]
      // },
      // // 价格管理
      // {
      //     path: '/material/price',
      //     name: 'material_price',
      //     meta: {
      //         title: '价格管理',
      //         parentPath: '/material',
      //         icon: 'icon_price',
      //         permission: ['view'],
      //         keepAlive: true
      //     },
      //     redirect: '/material/price/setting',
      //     component: Blank,
      //     children: [
      //         {
      //             path: '/material/price/setting',
      //             name: 'material_price_setting',
      //             meta: {
      //                 title: '价格设置',
      //                 parentPath: '/material',
      //                 permission: ['view'],
      //                 keepAlive: true
      //             },
      //             component: () => import('@/views/material/price/setting.vue')
      //         },
      //         {
      //             path: '/material/price/adjust',
      //             name: 'material_price_adjust',
      //             meta: {
      //                 title: '价格调整',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/price/adjust.vue')
      //         },
      //         {
      //             path: '/material/price/history',
      //             name: 'material_price_history',
      //             meta: {
      //                 title: '价格历史',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/price/history.vue')
      //         }
      //     ]
      // },
      // // 供应商账单
      // {
      //     path: '/material/bill',
      //     name: 'material_bill',
      //     meta: {
      //         title: '供应商账单',
      //         parentPath: '/material',
      //         icon: 'icon_zhang_dan',
      //         permission: ['view'],
      //         keepAlive: true
      //     },
      //     redirect: '/material/bill/monthly',
      //     component: Blank,
      //     children: [
      //         {
      //             path: '/material/bill/monthly',
      //             name: 'material_bill_monthly',
      //             meta: {
      //                 title: '月度账单',
      //                 parentPath: '/material',
      //                 permission: ['view'],
      //                 keepAlive: true
      //             },
      //             component: () => import('@/views/material/bill/monthly.vue')
      //         },
      //         {
      //             path: '/material/bill/payment',
      //             name: 'material_bill_payment',
      //             meta: {
      //                 title: '付款管理',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/bill/payment.vue')
      //         },
      //         {
      //             path: '/material/bill/reconciliation',
      //             name: 'material_bill_reconciliation',
      //             meta: {
      //                 title: '对账管理',
      //                 parentPath: '/material',
      //                 permission: ['view']
      //             },
      //             component: () => import('@/views/material/bill/reconciliation.vue')
      //         }
      //     ]
      // },
      // // 仓库管理
      // {
      //     path: '/material/warehouse',
      //     name: 'material_warehouse',
      //     meta: {
      //         title: '仓库管理',
      //         parentPath: '/material',
      //         icon: 'icon_cang_ku',
      //         permission: ['view'],
      //         keepAlive: true
      //     },
      //     component: () => import('@/views/material/warehouse.vue')
      // },

      // === 隐藏路由（新增/编辑页面）===
      // 物料新增/编辑
      {
        path: '/material/add',
        name: 'material_add',
        meta: {
          hidden: true,
          title: '新增物料',
          parentPath: '/material',
          prevPath: '/material/inventory/lists'
        },
        component: () => import('@/views/material/inventory/add.vue')
      },
      {
        path: '/material/edit',
        name: 'material_edit',
        meta: {
          hidden: true,
          title: '编辑物料',
          parentPath: '/material',
          prevPath: '/material/inventory/lists'
        },
        component: () => import('@/views/material/inventory/add.vue')
      },
      // // 分类新增/编辑
      {
        path: '/material/category_add',
        name: 'material_category_add',
        meta: {
          hidden: true,
          title: '新增分类',
          parentPath: '/material',
          prevPath: '/material/category'
        },
        component: () => import('@/views/material/category_edit.vue')
      },
      {
        path: '/material/category_edit',
        name: 'material_category_edit',
        meta: {
          hidden: true,
          title: '编辑分类',
          parentPath: '/material',
          prevPath: '/material/category'
        },
        component: () => import('@/views/material/category_edit.vue')
      },
      // // 供应商新增/编辑
      {
        path: '/material/supplier_add',
        name: 'material_supplier_add',
        meta: {
          hidden: true,
          title: '新增供应商',
          parentPath: '/material',
          prevPath: '/material/supplier/lists'
        },
        component: () => import('@/views/material/supplier/edit.vue')
      },
      {
        path: '/material/supplier_edit',
        name: 'material_supplier_edit',
        meta: {
          hidden: true,
          title: '编辑供应商',
          parentPath: '/material',
          prevPath: '/material/supplier/lists'
        },
        component: () => import('@/views/material/supplier/edit.vue')
      },
      // // 采购订单新增/编辑/详情
      // {
      //     path: '/material/purchase_order_add',
      //     name: 'material_purchase_order_add',
      //     meta: {
      //         hidden: true,
      //         title: '新增采购订单',
      //         parentPath: '/material',
      //         prevPath: '/material/purchase/order'
      //     },
      //     component: () => import('@/views/material/purchase/order_add.vue')
      // },
      // {
      //     path: '/material/purchase_order_edit',
      //     name: 'material_purchase_order_edit',
      //     meta: {
      //         hidden: true,
      //         title: '编辑采购订单',
      //         parentPath: '/material',
      //         prevPath: '/material/purchase/order'
      //     },
      //     component: () => import('@/views/material/purchase/order_edit.vue')
      // },
      // {
      //     path: '/material/purchase_order_detail',
      //     name: 'material_purchase_order_detail',
      //     meta: {
      //         hidden: true,
      //         title: '采购订单详情',
      //         parentPath: '/material',
      //         prevPath: '/material/purchase/order'
      //     },
      //     component: () => import('@/views/material/purchase/order_detail.vue')
      // },
      // // 入库单详情
      // {
      //     path: '/material/inbound_detail',
      //     name: 'material_inbound_detail',
      //     meta: {
      //         hidden: true,
      //         title: '入库单详情',
      //         parentPath: '/material',
      //         prevPath: '/material/inbound/lists'
      //     },
      //     component: () => import('@/views/material/inbound/detail.vue')
      // },
      // // 出库单详情
      // {
      //     path: '/material/outbound_detail',
      //     name: 'material_outbound_detail',
      //     meta: {
      //         hidden: true,
      //         title: '出库单详情',
      //         parentPath: '/material',
      //         prevPath: '/material/outbound/lists'
      //     },
      //     component: () => import('@/views/material/outbound/detail.vue')
      // },
      // // 盘点单详情
      // {
      //     path: '/material/check_detail',
      //     name: 'material_check_detail',
      //     meta: {
      //         hidden: true,
      //         title: '盘点单详情',
      //         parentPath: '/material',
      //         prevPath: '/material/check/lists'
      //     },
      //     component: () => import('@/views/material/check/detail.vue')
      // },
      // // 仓库新增/编辑
      // {
      //     path: '/material/warehouse_add',
      //     name: 'material_warehouse_add',
      //     meta: {
      //         hidden: true,
      //         title: '新增仓库',
      //         parentPath: '/material',
      //         prevPath: '/material/warehouse'
      //     },
      //     component: () => import('@/views/material/warehouse_edit.vue')
      // },
      // {
      //     path: '/material/warehouse_edit',
      //     name: 'material_warehouse_edit',
      //     meta: {
      //         hidden: true,
      //         title: '编辑仓库',
      //         parentPath: '/material',
      //         prevPath: '/material/warehouse'
      //     },
      //     component: () => import('@/views/material/warehouse_edit.vue')
      // },

      // 物料详情页面
      {
        path: '/material/detail',
        name: 'material_detail',
        meta: {
          hidden: true,
          title: '物料详情',
          parentPath: '/material',
          prevPath: '/material/inventory/lists'
        },
        component: () => import('@/views/material/inventory/detail.vue')
      },
      // 物料批量导入
      {
        path: '/material/inventory/import',
        name: 'material_inventory_import',
        meta: {
          hidden: true,
          title: '批量导入物料',
          parentPath: '/material',
          prevPath: '/material/inventory/lists'
        },
        component: () => import('@/views/material/inventory/import.vue')
      }
      //     // 价格调整审批
      //     {
      //         path: '/material/price_adjust_audit',
      //         name: 'material_price_adjust_audit',
      //         meta: {
      //             hidden: true,
      //             title: '价格调整审批',
      //             parentPath: '/material',
      //             prevPath: '/material/price/adjust'
      //         },
      //         component: () => import('@/views/material/price/adjust_audit.vue')
      //     },
      //     // 月度账单详情
      //     {
      //         path: '/material/bill_detail',
      //         name: 'material_bill_detail',
      //         meta: {
      //             hidden: true,
      //             title: '账单详情',
      //             parentPath: '/material',
      //             prevPath: '/material/bill/monthly'
      //         },
      //         component: () => import('@/views/material/bill/detail.vue')
      //     }

    ]
  }
]
export default routes
